import { useParams, useNavigate } from "react-router-dom";
import { useTask, useCompleteTask } from "@/features/task/hooks";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Check } from "lucide-react";

export function TaskDetailPage() {
  const { id } = useParams<{ id: string }>();
  const nav = useNavigate();
  const numId = Number(id);
  const { data: task, isLoading } = useTask(Number.isFinite(numId) ? numId : undefined);
  const complete = useCompleteTask();

  if (isLoading) return <div className="text-muted-foreground">Đang tải...</div>;
  if (!task) return <div className="text-muted-foreground">Không tìm thấy nhiệm vụ.</div>;

  return (
    <div>
      <div className="flex items-center gap-2 mb-3">
        <Button size="sm" variant="ghost" onClick={() => nav(-1)}>
          <ArrowLeft className="h-4 w-4" /> Quay lại
        </Button>
        <h1 className="text-xl font-semibold flex-1">{task.taskName}</h1>
        {!task.isCompleted && (
          <Button
            size="sm"
            onClick={() => complete.mutate({ id: task.taskId, percent: 100, completed: true })}
          >
            <Check className="h-4 w-4 mr-1" /> Đánh dấu hoàn thành
          </Button>
        )}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm mb-4">
        <div>
          <span className="text-muted-foreground">Bắt đầu:</span> {task.startTime ?? "—"}
        </div>
        <div>
          <span className="text-muted-foreground">Kết thúc:</span> {task.endTime ?? "—"}
        </div>
        <div>
          <span className="text-muted-foreground">Chỉ huy:</span> {task.commanderId ?? "—"}
        </div>
        <div>
          <span className="text-muted-foreground">Người thực hiện:</span>{" "}
          {task.enforcementId ?? "—"}
        </div>
        <div>
          <span className="text-muted-foreground">% Hoàn thành:</span> {task.completedPercent ?? 0}%
        </div>
        <div>
          <span className="text-muted-foreground">Trạng thái:</span> {task.status ?? "—"}
        </div>
      </div>
      <section className="mb-4">
        <h2 className="font-semibold mb-2">Nội dung</h2>
        <div className="text-sm whitespace-pre-wrap rounded-md border border-border p-3 bg-muted/30">
          {task.content ?? "—"}
        </div>
      </section>
      <section className="mb-4">
        <h2 className="font-semibold mb-2">Mục tiêu</h2>
        <div className="text-sm whitespace-pre-wrap rounded-md border border-border p-3 bg-muted/30">
          {task.target ?? "—"}
        </div>
      </section>
      <section>
        <h2 className="font-semibold mb-2">Kết quả</h2>
        <div className="text-sm whitespace-pre-wrap rounded-md border border-border p-3 bg-muted/30">
          {task.taskResult ?? "—"}
        </div>
      </section>
    </div>
  );
}
